import Vue from 'vue'
import App from './App'
import router from './router'
import store from './mainVuex'
import Loader from './plugins/loader'
import VueMask from 'v-mask'
import VueNumeric from 'vue-numeric'

import ElementUI from 'element-ui'
// import VueI18n from 'vue-i18n';
// import messages from './i18n';
import i18n from './i18n';
// import 'element-ui/lib/theme-default/index.css'
import './assets/css/element/theme-sgs/index.css'
import * as VueGoogleMaps from 'vue2-google-maps';

import ModulePanelTemplate from './components/root/main/ModulePanelTemplate.vue';
import ModuleTemplate from './components/root/main/ModuleTemplate.vue';
import BootstrapAlertErrors from 'src/components/utils/BootstrapAlertErrors.vue';
import SgsRender from 'src/components/utils/sgs/SgsRender.vue';
import SgsRenderFile from 'src/components/utils/sgs/SgsRenderFile.vue';
import SgsRenderButtonReport from 'src/components/utils/sgs/SgsRenderButtonReport.vue';
import SgsRenderButtonForm from 'src/components/utils/sgs/SgsRenderButtonForm.vue';
import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts';
import loadExporting from 'highcharts/modules/exporting';
import load3d from 'highcharts/highcharts-3d';
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';

//TODO - MOVER PARA UM ARQUIVO SEPARADO
String.prototype.replaceAll = function(from, to){
  var str = this;
  var pos = str.indexOf(from);
  while (pos > -1){
    str = str.replace(from, to);
    pos = str.indexOf(from);
  }
  return (str);
};

Vue.use(Loader, store);

// Vue.use(VueI18n);

/*const i18n = new VueI18n({
  locale: 'pt',
  messages
});*/

Vue.use(ElementUI, {
  i18n: key => i18n.t(key)
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBvWE_sIwKbWkiuJQOf8gSk9qzpO96fhfY',
    libraries: 'places'
  }
});

Vue.use(VueNumeric);

Vue.use(VueMask);
loadExporting(Highcharts);
load3d(Highcharts);

Vue.use(VueHighcharts, { Highcharts });

Vue.use(require('vue-full-calendar'));
window.jQuery = window.$ = require('jquery');

Vue.component('modulePanel', ModulePanelTemplate);
Vue.component('SgsRender', SgsRender);
Vue.component('SgsRenderFile', SgsRenderFile);
Vue.component('SgsRenderButtonReport', SgsRenderButtonReport);
Vue.component('SgsRenderButtonForm', SgsRenderButtonForm);
Vue.component('moduleTemplate', ModuleTemplate);
Vue.component('BootstrapAlertErrors', BootstrapAlertErrors);

var EventBus = new Vue();

Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get: function () {
      return EventBus
    }
  }
});

// Require Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min');

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css');

require('font-awesome/css/font-awesome.css');
require('froala-editor/css/froala_style.min.css');
// Import and use Vue Froala lib.

highchartsMore(Highcharts);
solidGauge(Highcharts);
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala);

// máscara para moeda
import money from './components/utils/3rd/v-money'
Vue.use(money);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  el: '#app',
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js